module.exports = __webpack_public_path__ + "img/google-play-store.32b0b003.jpg";